export default __webpack_public_path__ + "static/media/login_2.ab299dbd.png";